import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/B5';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得要保人指定匯款帳號資訊
export function getInfoB5() {
    return get(`${url}/info`);
}

// 取得銀行的總行下拉選單
export function getBankInfoB5() {
    return get(`${url}/bankInfo`);
}

// 取得銀行的分行下拉選單，只有台幣帳戶可以搜尋分行
// "bankNo": "string" 傳入總行代碼
export function getBranchBankInfoB5(bankNo) {
    return post(`${url}/branchBankInfo`, { bankNo: bankNo });
}

// 送出要保人指定匯款帳號資訊
// "headBankNo": "string",銀行總行代號
// "branchBankNo": "string",銀行分行代號，只有台幣帳戶需要輸入
// "bankAccount": "string",銀行帳戶
// "bankAccountName": "string"銀行帳戶名，只有外幣帳戶需要輸入，因為台幣帳戶的戶名固定會是要保人姓名
export function submitB5(data) {
    return post(`${url}/submit`, data, {
        ...options,
        errorDialog: false,
        repeatRequestCancel: true,
        closeAlert: true,
    });
}
